// extracted by mini-css-extract-plugin
module.exports = {"formSection":"FormSection_formSection__bVQPs"};